import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { ReactComponent as AiCloseCircle } from '../../../assets/SVG/aiCloseCircle.svg';
import { selectedChipCloseSx } from '../Stocks/stock.helper';


interface SelectedChipProps {
  selectedItem: { id: number; label: string };
  onDelete: (id: number) => void;
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  variant?: 'filled' | 'outlined';
}

const SelectedChipSx = { 
  bgcolor: '#FCF3F0', 
  border: '1px solid #F9E5DF', 
  color: '#232323',
  fontWeight: 400,
  fontFamily: 'Nunito',
  maxWidth: 200,
  height: 32,
  paddingX: 0,
  paddingY: 1.5,
  fontSize: '12px',
  lineHeight: '145%',
  letterSpacing: 0,
  '.MuiAvatar-root': { width: 32, height: 32 },
  '.MuiChip-label': {
    marginRight: 0.35,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    width: '100%'
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: 2,
};


const SelectedChip: React.FC<SelectedChipProps> = ({
  selectedItem,
  onDelete,
  color = 'error',
  variant = 'outlined'
}) => {

  return (
    <Tooltip title={selectedItem.label} arrow>
      <span>
        <Chip
          key={selectedItem.id}
          label={selectedItem.label}
          onDelete={() => onDelete(selectedItem.id)}
          deleteIcon={<AiCloseCircle style={selectedChipCloseSx}  />}
          color={color}
          variant={variant}
          sx={{...SelectedChipSx}}
        />
      </span>
    </Tooltip>
  );
};

export default SelectedChip;
